<template>
<div class="big_contents" v-loading='loading'>
      <div class="content_box">
    <div class="title">
      <span class="text_left" @click="go()">场馆详情</span>
      <span class="text_right">当前页面:首页>体育场馆>{{datas.name}}</span>
    </div>
    <div class="img_box">
      <div class="img_box_left">
        <div class="vunue_in">
          <el-row :gutter="60">
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <div class="school_img">
                  <img :src="datas.logo" alt />
                </div>
                <div class="school_img_right">
                  <p>{{datas.name}}</p>
                  <span>
                    开放状态：
                    <em>{{datas.state==0?"正常开放":"临时关闭"}}</em>
                  </span>
                  <span>
                    现场人数：
                    <i>{{datas.peopleCount}}</i>人
                  </span>
                  <span>
                    学校地址：
                    <em>{{datas.address}}</em>
                  </span>
                  <span>
                    开放时间：
                    <em v-for="(item,index) in dateTime" :key="index">
                     {{item.day}}: {{item.startTime}}~{{item.endTime}}
                    </em>
                  </span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="map">
          <el-amap ref="map" vid="amapDemo" :amap-manager="amapManager" :center="center" :zoom="zoom"  class="amap-demo">
            <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position"  :visible="marker.visible"  :vid="index"></el-amap-marker>
          </el-amap>
        </div>
      </div>
      <div class="img_box_right">
        <div>
          <img src="../../assets/images/basketball.png" alt="">
        </div>
        <div>
          <img src="../../assets/images/bike.png" alt="">
        </div>
        <div>
          <img src="../../assets/images/swimming.png" alt="">
        </div>
        <div>
          <img src="../../assets/images/football.png" alt="">
        </div>
      </div>
    </div>
    </div>
</div>
</template>

<script>
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager()
    export default {
        name: "sportsVenueInfo",
        data(){
          return{
            loading:false,
            amapManager,
             zoom: 15,
            center: [0, 0],
            markers:[
            {
              position:[0, 0],
            }
          ],
            datas:{},
            dateTime:[],
            // formInline:{
            //   region:'',
            //   user:''
            // }
          }
        },
        methods:{
          //数组冒泡排序
          compare(prop){
            return (a,b)=>{
              var value1 = a[prop]
              var value2 =b[prop]
              return value1 - value2
            }
          },
          setData(){
            this.loading = true
            this.$axios.post('schoolManager/detailById',{schooId:this.$route.query.id}).then(res=>{
              if(res.data.code == 200&&res.data.result){
                this.datas = res.data.result
                let a = {position:[]}
            a.position[0]=res.data.result.longitude
            a.position[1]=res.data.result.latitude
            this.center = [res.data.result.longitude,res.data.result.latitude]
            this.markers.push(a)
                if(res.data.result.titleOpenTime){
                  this.dateTime =  res.data.result.titleOpenTime.openTimes
                console.log(this.dateTime,5656)
                this.dateTime.sort(this.compare('day'))
                for(let i = 0;i<this.dateTime.length;i++){
                  if(this.dateTime[i].day==1){
                    // this.dateTime[0]=res.data.result.openTime[i]
                    this.dateTime[i].day ='星期一'
                  }
                  if(this.dateTime[i].day==2){
                    // this.dateTime[1]=res.data.result.openTime[i]
                   this.dateTime[i].day ='星期二'
                  }
                  if(this.dateTime[i].day==3){
                    // this.dateTime[2]=res.data.result.openTime[i]
                    this.dateTime[i].day ='星期三'
                  }
                  if(this.dateTime[i].day==4){
                    // this.dateTime[3]=res.data.result.openTime[i]
                    this.dateTime[i].day ='星期四'
                  }
                  if(this.dateTime[i].day==5){
                    // this.dateTime[4]=res.data.result.openTime[i]
                    this.dateTime[i].day ='星期五'
                  }
                  if(this.dateTime[i].day==6){
                    // this.dateTime[5]=res.data.result.openTime[i]
                    this.dateTime[i].day ='星期六'
                  }
                  if(this.dateTime[i].day==7){
                    // this.dateTime[6]=res.data.result.openTime[i]
                    this.dateTime[i].day ='星期日'
                  }
                }
                }


              }
              this.loading = false
            })
          },
          go(){
            this.$router.go(-1)
          }
        },
        mounted(){
          this.setData()
        }
    }
</script>

<style  lang='less'>
  .big_contents{
    .content_box {
  width: 1200px;
  height: 817px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
  border: 1px solid #e5e5e5;
  .title {
    height: 56px;
    line-height: 56px;
    .text_left {
      cursor: pointer;
      float: left;
      margin-left: 34px;
      color: #25b1f7;
      font-size: 18px;
    }
    .text_right {
      float: right;
      margin-right: 40px;
      color: #999999;
      font-size: 14px;
    }
  }
  .img_box {
    display: flex;
    width: 1153px;
    height: 760px;
    border-top: 1px solid #e5e5e5;
    margin-left: 24px;
    box-sizing: border-box;
    padding-top: 40px;
    .img_box_left{
      width: 782px;
      height: 100%;
      .search {
        overflow: hidden;
        // margin-top: 20px;
        width: 782px;
        height: 50px;
        background-color: #36d982;
        border-radius: 6px;
        .text {
          display: inline-block;
          width: 167px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #fff;
        }
        .el-form--inline .el-form-item{
        vertical-align: -webkit-baseline-middle;
      }
      .el-form-item{
        margin-bottom: 12px;
      }
      .el-input--suffix .el-input__inner{
        width: 200px;
        height: 30px;
      }
      .el-input__inner{
        width: 255px;
        height: 30px;
      }
      .el-button{
        width: 80px;
        height: 30px;
        line-height: 12px;
        background-color: #fff;
        border: none;
        color: #333333;
        margin-top: 10px;
      }
      }
      .vunue_in {
        width: 782px;
        // height: 440px;
        .el-row{
          // display: inline-block;
          // float: left;
        }
        .grid-content {
            border-radius: 4px;
            min-height: 36px;
            margin-top: 25px;
            // width: 360px;
            height: 200px;
            display: flex;
            margin-right: 30px;
          }
        .school_img {
          display: inline-block;
          width: 120px;
          height: 120px;
          text-align: center;
          box-sizing: border-box;
          border: 1px solid rgba(229, 229, 229, 1);
          border-radius: 10px;
          img {
            // margin-top: 30px;
            width: 100%;
            height: 100%;
          }
        }
        .school_img_right {
          flex: 1;
          margin-left: 20px;
          p {
            font-size: 16px;
            color: #333333;
            margin-bottom: 10px;
          }
          span {
            display: block;
            font-size: 14px;
            margin-bottom: 10px;
            color: #999999;
            i {
              color: #ff3e59;
              font-style: normal;
            }
            em {
              font-style: normal;
            }
          }
        }
      }
      .map{
          width:799px;
          height: 428px;
          background-color: #898989;
        }
    }
    .img_box_right{
      flex: 1;
      margin-left: 80px;
      height:100% ;
      // background-color: #556699;
      div{
        width: 100%;
        height: 168px;
        margin-bottom: 2px;
        img{

          width: 100%;
          height: 100%;
        }
      }
    }
  }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/detailPage/sportsVenueInfo.vue